import React, { useState, useEffect, useRef, useCallback } from 'react';
import MeetingItem from '../components/MeetingItem';
import LoadingOverlay from '../components/LoadingOverlay';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaRegClock } from 'react-icons/fa';
import { BsCalendar3 } from 'react-icons/bs';
import { useNoobookContext } from '../context/NoobookContext';
import { getMyBooksByStatus, getMyBooksWishToRead } from '../api/BookcaseApi';
import { getMyBookcommunities } from '../api/BookcommunityApi';
import { processApiResponse } from '../common/errorMessage';
import { ownership2text, ActivityType, communityType2text } from '../common/enums';
import { useUserInfoQuery } from '../react-queries/queries';
import { getDday } from '../common/utils';
import BookDetailPage from './BookDetailPage';
import { FaTimes } from 'react-icons/fa';
import MoimDetailPage from './MoimDetailPage';
import { getAccessToken } from '../react-queries/queries';
import BookCaseImage from '../components/BookCaseImage';
import BookCoverImage from '../components/BookCoverImage';

// 샘플 이미지 10개 배열
const sampleImages = [
  '/book_sample1.jpeg',
  '/book_sample2.jpeg',
  '/book_sample3.jpeg',
  '/book_sample4.jpeg',
  '/book_sample5.jpeg',
  '/book_sample6.jpeg',
  '/book_sample7.jpeg',
  '/book_sample8.jpeg',
  '/book_sample9.jpeg',
  '/book_sample10.jpeg',
];

// 읽고 싶은 책 샘플 이미지 10개 (다른 배열로 분리 가능)
const wishImages = [
  '/book_sample11.jpeg',
  '/book_sample12.jpeg',
  '/book_sample13.jpeg',
  '/book_sample14.jpeg',
  '/book_sample15.jpeg',
  '/book_sample16.jpeg',
  '/book_sample17.jpeg',
  '/book_sample18.jpeg',
  '/book_sample19.jpeg',
  '/book_sample20.jpeg',
];

// 참여모임 데이터는 이제 API에서 가져옵니다

const Wrapper = styled.div`
  background: #f5f5f5;
  min-height: 100vh;
  padding: 0;
`;


const BookScrollRow = styled.div`
  display: flex;
  gap: 30px;
  overflow-x: auto;
  padding: 0 20px 16px 20px;
  box-sizing: border-box;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
`;

const EmptyBookScrollRow = styled.div`
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  gap: 16px;
`;

const EmptyBookCaseScrollRow = styled.div`
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px 0px 20px;
  margin: 0 20px;
  gap: 16px;
  border-radius: 12px;
  background: #fff;
`;


const EmptyBookMessage = styled.div`
  font-size: 16px;
  color: #666;
  text-align: center;
`;

const EmptyBookButton = styled.button`
  background: #636363;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  
  &:hover {
    background: #d1d5db;
  }
`;

const BookCard = styled.div`
  flex: 0 0 100%;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  scroll-snap-align: start;
`;

const BookCardInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`;

const DdayBadge = styled.div`
  background: #636363;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 4px;
  display: inline-block;
  white-space: nowrap;
  font-weight: 400;
  margin-bottom: 8px;
`;

const BookTitle = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
`;

const BookMeta = styled.div`
  font-size: 15px;
  color: #888;
  margin-bottom: 4px;
`;

const BookPeriod = styled.div`
  font-size: 13px;
  color: #888;
  margin-bottom: 10px;
`;

const BookBadge = styled.div`
  background: #1976d2;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  padding: 2px 4px;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  min-width: 0;
  width: fit-content;
`;

const BookCaseScrollRow = styled.div`
  display: flex;
  gap: 0px;
  overflow-x: auto;
  padding: 0 20px 0px 20px;
  margin: 0 20px;
  border-radius: 12px;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  background: #fff;
`;



const BookCaseCard = styled.div`
  width: 100%;
  background: #fff;
  padding: 16px 16px 16px 20px;
  margin: 20 0 20 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 22px;
  scroll-snap-align: start;
  flex-shrink: 0;
`;



const BookCaseItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 88px;
  flex-shrink: 0;
  cursor: pointer;
`;

const BookCaseTitle = styled.div`
  width: 88px;
  margin-top: 8px;
  font-size: 13px;
  color: #222;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PlanBookGroup = styled.div`
  display: flex;
  gap: 20px;
  padding: 15px;
  justify-content: center;
  background: #fff;
  border-radius: 12px;
  margin: 0 20px;
  min-width: 100%;
  scroll-snap-align: start;
`;


const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;


const BookDetailModal = ({bookId, onClose, onModified }) => {
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>나의 독서노트</ModalTitle>
        <ModalCloseButton onClick={()=>{onClose(false);}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        <BookDetailPage propBookId={bookId} onClose={onClose} onModified={onModified} />
      </ModalContent>
    </Modal>
  )
};


const MoimDetailModal = ({bookCommunityId, onClose, onModified }) => {
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>상세 보기</ModalTitle>
        <ModalCloseButton onClick={()=>{onClose();}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        <MoimDetailPage bookCommunityId={bookCommunityId} onModified={onModified} />
      </ModalContent>
    </Modal>
  )
};



export function NudokPage() {
  const [startIndex, setStartIndex] = useState(0);
  //const visibleImages = sampleImages.slice(startIndex, startIndex + 3);
  const total = sampleImages.length;
  const endIndex = Math.min(startIndex + 3, total);
  //const canPrev = startIndex > 0;
  //const canNext = endIndex < total;

  const [wishStart, setWishStart] = useState(0);
  const wishTotal = wishImages.length;
  const wishEnd = Math.min(wishStart + 3, wishTotal);
  //const wishVisible = wishImages.slice(wishStart, wishStart + 3);
  //const wishCanPrev = wishStart > 0;
  //const wishCanNext = wishEnd < wishTotal;

  const [meetingIndex, setMeetingIndex] = useState(0);
  const [meetingList, setMeetingList] = useState([]);
  const canPrevMeeting = meetingIndex > 0;
  const canNextMeeting = meetingIndex < meetingList.length - 1;
  const visibleMeeting = meetingList.slice(meetingIndex, meetingIndex + 1);



  const groupBooks = (books, groupSize) => {
    const groups = [];
    for (let i = 0; i < books.length; i += groupSize) {
      groups.push(books.slice(i, Math.min(i + groupSize, books.length)));
    }
    return groups;
  }



  const [books, setBooks] = useState([]);
  const [page, setPage] = useState(0);
  const [totalBooks, setTotalBooks] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [wishBooks, setWishBooks] = useState([]);
  const [wishPage, setWishPage] = useState(0);
  const [wishHasMore, setWishHasMore] = useState(true);
  const [planBooks, setPlanBooks] = useState([]);
  const [planPage, setPlanPage] = useState(0);
  const [planHasMore, setPlanHasMore] = useState(true);
  const [selBookId, setSelBookId] = useState(null);
  const [selBookCommunityId, setSelBookCommunityId] = useState(null);
  const [isMoimDetailModified, setIsMoimDetailModified] = useState(false);
  const [isBookDetailModified, setIsBookDetailModified] = useState(false);
  const scrollRef = useRef();
  const planScrollRef = useRef();
  const wishScrollRef = useRef();

  const {data: userInfo} = useUserInfoQuery();


  const navigate = useNavigate();
  const { showBack, setShowBack, onBookRegistered , setOnBookRegistered } = useNoobookContext();
  const [loading, setLoading] = useState(false);
  const [showBookDetailModal, setShowBookDetailModal] = useState(false);
  const [showMoimDetailModal, setShowMoimDetailModal] = useState(false);
  // authToken 획득
  //const authToken = localStorage.getItem('accessToken');
 

  useEffect(() => {
    const prevShowBack = showBack;
    const prevOnBookRegistered = onBookRegistered;
    setShowBack(false);
    setOnBookRegistered(() => () => {
      //alert('onBookRegistered');
      loadAllBooks(page);
    });
    loadAllBooks(page);
    loadMyBookcommunities();
    // eslint-disable-next-line
    return () => {
      setShowBack(prevShowBack);
      setOnBookRegistered(() => prevOnBookRegistered);
    };
  }, []);

  // 뒤로가기 버튼으로 모달 닫기
  useEffect(() => {
    const handlePopState = (event) => {
      if (showBookDetailModal) {
        event.preventDefault();
        handleBookDetailClose(isBookDetailModified)
/*
        if (isBookDetailModified) {
          loadAllBooks();
          setIsBookDetailModified(false);
        }
        setShowBookDetailModal(false);*/
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      } else if (showMoimDetailModal) {
        event.preventDefault();
        handleMoimDetailClose(isMoimDetailModified)

/*
        if (isMoimDetailModified) {
          loadMyBookcommunities();
          setIsMoimDetailModified(false);
        }
        setShowMoimDetailModal(false);*/
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      }
    };

    // 모달이 열려있을 때만 history state를 push하고 이벤트 리스너 등록
    if (showBookDetailModal || showMoimDetailModal) {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showBookDetailModal, showMoimDetailModal, isBookDetailModified, isMoimDetailModified]);

  const loadAllBooks = async () => {
    try{
      if (loading) return;
      setLoading(true);
      await loadBooks(page, true);
      await loadPlanBooks(planPage, true);
      await loadWishBooks(wishPage, true);
    } catch (error) {
      console.error('loadAllBooks 처리중 오류 발생:', error);
    } finally {
      setLoading(false);
    }
  }

  const loadMyBookcommunities = async () => {
   
    try {
      const {accessToken} = await getAccessToken();
      const res = await getMyBookcommunities(accessToken, ActivityType.BOOK_REVIEW);
      const processedResponse = processApiResponse(res);
      if (!processedResponse.success) {
        console.error('내 북커뮤니티 검색 중 오류 발생:', processedResponse.errorMessage);
        setMeetingList([]);
        return;
      }
      setMeetingList(processedResponse.data || []);
    } catch (error) {
      console.error('내 북커뮤니티 검색 중 오류 발생:', error);
      setMeetingList([]);
    }
  }
  const loadPlanBooks = async (nextPage, noNeedLoading) => {
    
    if (loading && !noNeedLoading) return;
    try{
      setLoading(true);
      const {accessToken} = await getAccessToken();
      const res = await getMyBooksByStatus(accessToken, 'PLAN_TO_READ', null, nextPage, 50);
      const processedResponse = processApiResponse(res);
      if (!processedResponse.success) {
        console.error('읽을 예정인 책 검색 중 오류 발생:', processedResponse.errorMessage);
        setPlanHasMore(false);
        setPlanBooks(prev => Array.isArray(prev) ? prev : []);
        return;
      }
     
      if(0 === processedResponse?.page?.current){
        setPlanBooks(processedResponse.data);
        setPlanPage(0);
      }else if(planPage+1===processedResponse?.page?.current){
        setPlanBooks(prev => [...prev, ...processedResponse.data] );
        setPlanPage(nextPage);
      }
      setPlanHasMore(processedResponse.data.length === 50);
    } catch (error) {
      console.error('읽을 예정인 책 검색 중 오류 발생:', error);
      setPlanHasMore(false);
      setPlanBooks(prev => Array.isArray(prev) ? prev : []);
    } finally {
      if (!noNeedLoading) setLoading(false);
    }
  }

  const loadWishBooks = async (nextPage, noNeedLoading) => {
    
    
    if (loading && !noNeedLoading) return;
    try{  
      setLoading(true);
      const {accessToken} = await getAccessToken();
      const res = await getMyBooksWishToRead(accessToken, nextPage, 50);
      const processedResponse = processApiResponse(res);
      if (!processedResponse.success) {
        console.error('읽고 싶은 책 검색 중 오류 발생:', processedResponse.errorMessage);
        setWishHasMore(false);  
        setWishBooks(prev => Array.isArray(prev) ? prev : []);
        return;
      }
      if(0 === processedResponse?.page?.current){
        setWishBooks(processedResponse.data);
        setWishPage(0);
      }else if(wishPage+1===processedResponse?.page?.current){
        setWishBooks(prev => [...prev, ...processedResponse.data] );
        setWishPage(nextPage);
      }
      setWishHasMore(processedResponse.data.length === 50);
    } catch (error) {
      console.error('읽고 싶은 책 검색 중 오류 발생:', error);
      setWishHasMore(false);
      setWishBooks(prev => Array.isArray(prev) ? prev : []);
    } finally {
      if (!noNeedLoading) setLoading(false);
    }
  }

  const loadBooks = async (nextPage, noNeedLoading) => {
   
    
    if (loading && !noNeedLoading) return;
    try{
    setLoading(true);
    const {accessToken} = await getAccessToken();
    const res = await getMyBooksByStatus(accessToken, 'READING', null, nextPage, 50);

    const processedResponse = processApiResponse(res);

    if (!processedResponse.success) {
      console.error('읽는 중인 책 검색 중 오류 발생:', processedResponse.errorMessage);
      setHasMore(false);
      setBooks(prev => Array.isArray(prev) ? prev : []);
      return;
    }
    setTotalBooks(processedResponse?.page?.total??0);

    if(0 === processedResponse?.page?.current){
      setBooks(processedResponse.data);
      setPage(0);
    }else if(page+1===processedResponse?.page?.current){
      setBooks(prev => [...prev, ...processedResponse.data] );
      setPage(nextPage);
    }
    setHasMore(processedResponse.data.length === 50);
    } catch (error) {
      console.error('읽는 중인 책 검색 중 오류 발생:', error);
      setHasMore(false);
      setBooks(prev => Array.isArray(prev) ? prev : []);
    } finally {
      if (!noNeedLoading) setLoading(false);
    }
  };

  // 무한 스크롤 감지
  const handleScroll = (e) => {
    const { scrollLeft, scrollWidth, clientWidth } = e.target;
    if (hasMore && scrollLeft + clientWidth >= scrollWidth - 10) {
      loadBooks(page + 1, false);
    }
  };

  const handleWishScroll = (e) => {
    const { scrollLeft, scrollWidth, clientWidth } = e.target;
    if (wishHasMore && scrollLeft + clientWidth >= scrollWidth - 10) {
      loadWishBooks(wishPage+1, false);
    }
  };

  const handlePlanScroll = (e) => {
    const { scrollLeft, scrollWidth, clientWidth } = e.target;
    if (planHasMore && scrollLeft + clientWidth >= scrollWidth - 10) {
      loadPlanBooks(planPage+1, false);
    }
  };

  const popupBookDetail = (bookId) => {
    setSelBookId(bookId);
    setShowBookDetailModal(true);
  };

  const handleBookDetailClose = (modified) => {
    if(modified) {
      loadAllBooks();
      setIsBookDetailModified(false);
    }
    setShowBookDetailModal(false);
  };

  const handleBookDetailModified = (modified) => {
    if(modified) {
      setIsBookDetailModified(true);
    }
  };

  const popupMoimDetail = (bookCommunityId) => {
    console.log('popupMoimDetail', bookCommunityId);
    setSelBookCommunityId(bookCommunityId);
    setShowMoimDetailModal(true);
  };

  const handleMoimDetailClose = (modified) => {
    setShowMoimDetailModal(false);
    if(modified) {
      loadMyBookcommunities();
      setIsMoimDetailModified(false);
    }
  };

  const handleMoimDetailModified = (modified) => {
    //setShowMoimDetailModal(false);
    if(modified) {
      //loadMyBookcommunities();
      setIsMoimDetailModified(true);
    }
  };

  // 첨부 이미지 참고한 누독 화면 임시 구현
  return (
    <Wrapper>
      <div style={{padding: '0 0 80px 0', background: '#eae8e9', minHeight: '100vh'}}>
        <div style={{padding: '0 12px'}}>
          <div style={{fontSize: '22px', margin: '12px 0 0 0', paddingLeft: 4, color: '#3e3e3e'}}>
            <span style={{fontWeight: 700}}>{userInfo?.name??userInfo?.loginid}님</span> {totalBooks>0 && <span style={{fontSize: '20px', fontWeight: 400}}>({totalBooks}권의 책을 읽고 있습니다)</span>}
          </div>
          <div style={{fontWeight: 700, fontSize: '20px', color: '#3e3e3e', marginBottom: 12, paddingLeft: 4, paddingBottom: 10}}>
            오늘은 무슨 책을 읽으셨나요?
          </div>
        </div>
        {books.length === 0 ? (
          <EmptyBookScrollRow>
            <EmptyBookMessage>지금 읽고 있는 책을 등록해보세요.</EmptyBookMessage>
            <EmptyBookButton onClick={() => navigate('/book-search')}>
              책등록하기
            </EmptyBookButton>
          </EmptyBookScrollRow>
        ) : (
          <BookScrollRow ref={scrollRef} onScroll={handleScroll}>
             {books.map(book => (
               <BookCard key={book.bookId} onClick={() => /*navigate(`/book/${book.bookId}`)*/popupBookDetail(book.bookId)}>
                 <BookCoverImage src={book.cover} alt={book.title} />
                 <BookCardInfo>
                   <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                     <DdayBadge>{getDday(book.readTo)}</DdayBadge>
                     <BookTitle>{book.title}</BookTitle>
                  </div>
                   <BookMeta>{book.author} / {book.publisher}</BookMeta>
                   <BookPeriod>
                     {book.readFr?.slice(0,10)} ~ {book.readTo?.slice(0,10)}
                   </BookPeriod>
                   <BookBadge>{ownership2text(book.ownership)?.trim()}</BookBadge>
                </BookCardInfo>
              </BookCard>
            ))}
          </BookScrollRow>
        )}
        {/*<SeparatorBar />*/}
        <div style={{background:'#393939', borderRadius:'24px 24px 0 0', padding:'24px 0 0 0', marginTop:2}}>
          <div style={{color:'#c3c3ce', fontSize:22, fontWeight:700, padding:'0 20px 12px 20px'}}>읽을 예정인 책</div>
          <div style={{position:'relative'}}>
          {planBooks.length === 0 ? (
          <EmptyBookCaseScrollRow>
            <EmptyBookMessage>곧 읽을 책을 담아두세요.</EmptyBookMessage>
            <EmptyBookButton onClick={() => navigate('/book-search')}>
              책등록하기
            </EmptyBookButton>
          </EmptyBookCaseScrollRow>
         ) : (<BookCaseScrollRow ref={planScrollRef} onScroll={handlePlanScroll}>
            {groupBooks(planBooks, 3).map((group, groupIndex) => (
              <BookCaseCard key={groupIndex}>
                {group.map((book) => (
                    <BookCaseItem key={book.bookId} onClick={() => popupBookDetail(book.bookId)}>
                      <BookCaseImage src={book.cover} alt={book.title} />
                      <BookCaseTitle>{book.title}</BookCaseTitle>
                    </BookCaseItem>
                  ))}
              </BookCaseCard>
            ))}
          </BookCaseScrollRow>) } 
          </div>
          <div style={{color:'#c3c3ce', fontSize:22, fontWeight:700, padding:'24px 0 12px 20px'}}>읽고 싶은 책</div>
          <div style={{position:'relative'}}>

           {/* <div style={{display:'flex', gap:20, padding:15, justifyContent:'center', background:'#fff', borderRadius:12, margin:'0 20px'}}>
              {wishVisible.map((src, i) => (
                <img key={src} src={src} alt={`wish${wishStart + i + 1}`} style={{width:88, height:128, borderRadius:0, objectFit:'cover'}} />
              ))}
            </div>
            {wishCanPrev && <button style={{position:'absolute', left:0, top:'50%', transform:'translateY(-50%)', zIndex:2, background:'rgba(0,0,0,0.1)', border:'none', borderRadius:16, width:32, height:32, cursor:'pointer'}} onClick={()=>setWishStart(Math.max(0, wishStart-3))}>&lt;</button>}
            {wishCanNext && <button style={{position:'absolute', right:0, top:'50%', transform:'translateY(-50%)', zIndex:2, background:'rgba(0,0,0,0.1)', border:'none', borderRadius:16, width:32, height:32, cursor:'pointer'}} onClick={()=>setWishStart(Math.min(wishTotal-3, wishStart+3))}>&gt;</button>}
            <div style={{position:'absolute', right:28, bottom:6, background:'rgba(0,0,0,0.5)', color:'#fff', fontSize:11, borderRadius:16, padding:'2px 10px', zIndex:3}}>
              {wishEnd} / {wishTotal}
            </div> */}
          { wishBooks.length === 0 ? (
          <EmptyBookCaseScrollRow>
            <EmptyBookMessage>언젠가 읽고 싶은 책을 담아두세요.</EmptyBookMessage>
            <EmptyBookButton onClick={() => navigate('/book-search')}>
              책등록하기
            </EmptyBookButton>
          </EmptyBookCaseScrollRow>
         ) : (<BookCaseScrollRow ref={wishScrollRef} onScroll={handleWishScroll}>
            {groupBooks(wishBooks, 3).map((group, groupIndex) => (
              <BookCaseCard key={groupIndex}>
                {group.map((book) => (
                    <BookCaseItem key={book.bookId} onClick={() => popupBookDetail(book.bookId)}>
                      <BookCaseImage src={book.cover} alt={book.title} />
                      <BookCaseTitle>{book.title}</BookCaseTitle>
                    </BookCaseItem>
                  ))}
              </BookCaseCard>
            ))}
          </BookCaseScrollRow>) }
          </div>
          <div style={{color:'#c3c3ce', fontSize:22, fontWeight:700, padding:'24px 0 12px 20px'}}>참여 모임</div>
          <div style={{position:'relative', padding:'0 0 20px 0px'}}>
            {visibleMeeting.length === 0? (
          <EmptyBookCaseScrollRow>
            <EmptyBookMessage>함께 읽을 사람을 찾아보세요.</EmptyBookMessage>
            <EmptyBookButton onClick={() => navigate('/moim')}>
              모임탐색하기
            </EmptyBookButton>
          </EmptyBookCaseScrollRow>
          ) : visibleMeeting.map((item) => (
              <MeetingItem
                key={item.id}
                image={item.imgUrl || '/moim_sample.png'}
                title={item.title || '제목 없음'}
                tag={`#${communityType2text(item.communityType)}`}
                description={item.briefIntroduction || '설명 없음'}
                hashtags={item.hashtags ? item.hashtags.map(tag => `#${tag}`).join(' ') : ''}
                index={meetingIndex + 1}
                total={meetingList.length}
                onClick={()=>popupMoimDetail(item.id)}
              />
            ))}
            {canPrevMeeting && <button style={{position:'absolute', left:0, top:'50%', transform:'translateY(-50%)', zIndex:2, background:'rgba(0,0,0,0.1)', border:'none', borderRadius:16, width:32, height:32, cursor:'pointer'}} onClick={()=>setMeetingIndex(meetingIndex-1)}>&lt;</button>}
            {canNextMeeting && <button style={{position:'absolute', right:0, top:'50%', transform:'translateY(-50%)', zIndex:2, background:'rgba(0,0,0,0.1)', border:'none', borderRadius:16, width:32, height:32, cursor:'pointer'}} onClick={()=>setMeetingIndex(meetingIndex+1)}>&gt;</button>}
          </div>
        </div>
      </div>
      {showMoimDetailModal && (
        <MoimDetailModal bookCommunityId={selBookCommunityId} onClose={()=>handleMoimDetailClose(isMoimDetailModified)} onModified={handleMoimDetailModified} />
      )}
      {showBookDetailModal && (
        <BookDetailModal bookId={selBookId} onClose={()=>handleBookDetailClose(isBookDetailModified)} onModified={handleBookDetailModified} />
      )}
      {loading && <LoadingOverlay />}
    </Wrapper>
  );
} 